function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { PromiseState } from "react-refetch";
import { context, updateContextState } from "../../components/wr-context";
import { isTokenProvisional } from "../../utils/token";
var login = function(param) {
    var email = param.email, password = param.password, cb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
    };
    return {
        loginResponse: context.actions.login ? {
            value: context.actions.login({
                email: email,
                password: password
            }, cb)
        } : {
            url: "".concat(context.constants.host, "/beta/users/auth"),
            method: "POST",
            body: JSON.stringify({
                email: email,
                password: password
            }),
            then: function(param) {
                var data = param.data;
                var client = context.constants.client;
                if (client.restrictLogin) {
                    // Make sure there is a single `@`
                    var ctxDomains = (client.emailDomains || []).map(function(e) {
                        return e.replace(/^@?/, "@");
                    });
                    var valDomain = (email || "").replace(/.+@/, "@");
                    var isValidDomain = _toConsumableArray(ctxDomains).concat([
                        "@workrails.com",
                        "@xogito.com"
                    ]).indexOf(valDomain) > -1;
                    var isValidEmail = [
                        "wr.test.default+prodpartner@gmail.com"
                    ].indexOf(email) > -1;
                    if (!isValidDomain && !isValidEmail) {
                        var defaultMsg = "You need a company email to access the catalog";
                        return {
                            value: PromiseState.reject(new Error(client.restrictLoginMessage || defaultMsg))
                        };
                    }
                }
                var token = data === null || data === void 0 ? void 0 : data.authorization.replace("Bearer ", "");
                updateContextState(function(state) {
                    state.isLoggedIn = !isTokenProvisional(token);
                    state.user = data === null || data === void 0 ? void 0 : data.user;
                    state.authorization = token;
                    cb(null, data);
                });
                if (!isTokenProvisional(token)) {
                    context.persistentStorage.set("token", token);
                }
            },
            catch: function(reason) {
                cb(reason);
            }
        }
    };
};
var loginTotp = function(param) {
    var rememberMe = param.rememberMe, mfaCode = param.mfaCode, provisionalToken = param.provisionalToken, cb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(reason, data) {};
    return {
        /**
   * @deprecated doesn't seem to be used anywhere
   */ loginTotpResponse: {
            url: "".concat(context.constants.host, "/api/v1/auth/totp-login"),
            method: "POST",
            body: JSON.stringify({
                data: {
                    rememberMe: rememberMe,
                    mfaCode: mfaCode,
                    provisionalToken: provisionalToken
                }
            }),
            then: function(param, param1) {
                var data = param.data, response = param1.response;
                var ref;
                var token = (ref = response.headers.get("Authorization")) === null || ref === void 0 ? void 0 : ref.replace("Bearer ", "");
                updateContextState(function(state) {
                    state.isLoggedIn = true;
                    state.user = data.user;
                    state.authorization = token;
                    cb(null, data);
                });
                context.persistentStorage.set("token", token);
            },
            catch: function(reason) {
                cb(reason);
            }
        }
    };
};
export default {
    login: login,
    loginTotp: loginTotp
};
